import { render, staticRenderFns } from "./SubmittedShow.vue?vue&type=template&id=43391634&scoped=true&"
import script from "./SubmittedShow.vue?vue&type=script&lang=js&"
export * from "./SubmittedShow.vue?vue&type=script&lang=js&"
import style0 from "./SubmittedShow.vue?vue&type=style&index=0&id=43391634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43391634",
  null
  
)

export default component.exports